import Typography from '@mui/material/Typography';

export default function PharmaGenesSubText() {
  
  return (
<Typography variant="subtitle2">
    
The <Typography component="span" fontWeight={600}>Phenotype </Typography> column reflects your predicted enzyme activity - this can influence how effective a medication is or whether you may be at increased risk of side effects. 
Each drug listed in your <Typography component="span" fontWeight={600}>Medication Guide</Typography> includes detailed, guideline-based recommendations tailored to your profile.​
<br /><br />
<ul style={{ paddingLeft: '20px' }}>
<li>
<Typography component="span" fontWeight={600}>Poor Metabolizer (PM):</Typography> Severely reduced or absent enzyme activity. Drugs may accumulate in the body, increasing the risk of side effects or toxicity. A lower dose or alternative medication may be recommended.​
</li>

<li>
<Typography component="span" fontWeight={600}>Intermediate Metabolizer (IM):</Typography> Reduced enzyme activity. May require dose adjustment depending on the drug.​
</li>

<li>
<Typography component="span" fontWeight={600}>Normal (or Extensive) Metabolizer (NM/EM):</Typography> Normal enzyme function. Standard dosing is typically effective.​
</li>

<li>
<Typography component="span" fontWeight={600}>Ultrarapid Metabolizer (UM):</Typography> Increased enzyme activity. Drugs may be broken down too quickly, potentially reducing their effectiveness. A higher dose or different drug may be considered.​
</li>

<li>
<Typography component="span" fontWeight={600}>Decreased/Increased Activity:</Typography> Enzyme function is below normal but not fully absent or if increased, it may enhance drug clearance. This can affect drug exposure and response.​
</li>

<li>
<Typography component="span" fontWeight={600}>Favorable/Unfavorable Response Allele:</Typography> In some cases, your genetic variant does not affects metabolism, but the probability of how well the drug is working or causing side effects. These responses guide whether a drug is expected to be more or less effective based on your genotype.​
</li>

</ul>
</Typography>

   )
}